module.exports = __webpack_public_path__ + "static/media/vit.b0d9629e.png";